// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"ExerciseValues_Wrap__29T2m","Icon":"ExerciseValues_Icon__24ZN8","Block":"ExerciseValues_Block__3Z4M0"};